function containedLocations(item, grp) {
  if (!item?.is_collection) return [];
  if (!item.drawing || !item.replace_with_drawing) return [];
  if (item.drawing.type !== "iiif") return [];

  const pageName = `${item.drawing.id}/doc.pdf`;
  const pageIndexStr = item.drawing.path.match(/doc\.(\d+)\.tiff/)?.[1];
  if (pageIndexStr == undefined) return [];
  const pageIndex = parseInt(pageIndexStr, 10);
  const minX = item.drawing.clip.x;
  const minY = item.drawing.clip.y;
  const maxX = minX + item.drawing.clip.width;
  const maxY = minY + item.drawing.clip.height;

  return grp.locations.order.filter((locId) => {
    const loc = grp.locations[locId];
    if (!loc) return false;
    const item = grp.items[loc.record_id];
    if (!item || item.is_collection) return false;
    const page = grp.documents[loc.document_id]?.data.pages?.[loc.page_id];
    if (!page) return false;
    if (page.name !== pageName) return false;
    if (pageIndex !== page.page) return false;
    return (
      loc.position.x >= minX &&
      loc.position.x <= maxX &&
      loc.position.y >= minY &&
      loc.position.y <= maxY
    );
  });
}

export default containedLocations;
